var Fe = Object.defineProperty;
var Qe = (n, e, t) => e in n ? Fe(n, e, { enumerable: !0, configurable: !0, writable: !0, value: t }) : n[e] = t;
var d = (n, e, t) => (Qe(n, typeof e != "symbol" ? e + "" : e, t), t);
const Ke = (n, e) => {
  const t = (s) => (typeof s != "boolean" && (s = !!s), s);
  if (n === "allTrue") {
    let s = !0;
    return { register: (r) => {
      s && (t(r) || (s = !1));
    }, executor: () => {
      s && e();
    } };
  } else if (n === "onceTrue") {
    let s = !1;
    return { executor: (o) => {
      s || t(o) && (s = !0, e());
    } };
  }
  throw new RangeError("unsupported mode");
}, Q = (n) => {
  let e;
  return function(...t) {
    return e ?? (e = n.apply(this, t));
  };
}, qe = (n, e) => {
  let t;
  return function(...s) {
    return t !== void 0 && e && (t = e(t)), t ?? (t = n.apply(this, s));
  };
}, We = (n) => window.getComputedStyle(n).display === "none", Ee = (n) => parseFloat(window.getComputedStyle(n).zIndex), Ze = qe((n) => {
  const e = Array.from(document.querySelectorAll("body *")), t = [];
  for (const s of e) {
    if (s === n)
      continue;
    const i = Ee(s);
    isNaN(i) || t.push(i);
  }
  return t.sort((s, i) => s - i).pop() ?? 0;
}), Je = (n, e, t) => {
  for (; n.length >= t; )
    n.shift();
  return n.push(e), e;
}, S = (n) => {
  const e = [], t = (s) => {
    e.push(s);
  };
  return new Proxy(
    {
      value: n
    },
    {
      get(s, i, o) {
        return i === "watch" ? t.bind(s) : Reflect.get(s, i, o);
      },
      set(s, i, o, r) {
        const c = s.value;
        try {
          return Reflect.set(s, i, o, r);
        } finally {
          e.forEach((l) => l(o, c));
        }
      }
    }
  );
}, Ve = (n, e) => new Proxy(n, {
  get(t, s, i) {
    if (s === "value")
      return e(t.value);
    if (s === "watch") {
      const o = Reflect.get(t, s, i);
      return (c) => o((l, u) => c(e(l), u));
    }
    return Reflect.get(t, s, i);
  }
}), Z = (n) => typeof n == "function" ? n() : n instanceof Object && "value" in n && typeof n.watch == "function" ? n.value : n;
function _e(n, e, t) {
  const s = Z(n);
  return typeof n == "function" ? (t == null || t(() => e == null ? void 0 : e(n())), s) : (n instanceof Object && n.value && n.watch((i) => {
    e(i);
  }), s);
}
const k = S({}), Xe = (n) => {
  n instanceof Object && (k.value = n);
}, ae = (n, e, t) => {
  if (t.length === 0)
    return n;
  if (!n || typeof n != "string")
    return "";
  const s = n.split("");
  let i = 0;
  for (let o = 0; o < s.length && i < e.length; o++)
    if (s[o] === "%") {
      const c = e[i], l = c.length;
      c === s.slice(o, o + l).join("") && (s.splice(o, l, t[i]), o--, i++);
    }
  return s.join("");
}, me = (n, e) => {
  e && n(), k.watch(n);
}, Ye = (n) => n in k.value, ge = (n) => !Ye(n) || k.value[n] === "", we = (n, ...e) => {
  const t = e.map((s, i) => `%${i + 1}`);
  return k.value[n] ? ae(k.value[n], t, e) : n;
}, p = (n, ...e) => {
  const t = e.map((i, o) => `%${o + 1}`), s = S(n);
  return k.value[n] && (s.value = ae(k.value[n], t, e.map((i) => Z(i)))), k.watch((i) => {
    if (typeof i[n] == "string") {
      s.value = ae(i[n], t, e.map((o) => Z(o)));
      return;
    }
    s.value = n;
  }), s;
}, w = class {
  constructor(e, t) {
    d(this, "_insertedQueue", []);
    d(this, "_readyQueue", []);
    d(this, "_childAsDoms", []);
    d(this, "_dirtyQueue", []);
    d(this, "_inDom", !1);
    d(this, "_listeners");
    d(this, "dom");
    d(this, "addEventListener", (e, t, s) => (this._listeners[e] || (this._listeners[e] = []), this._listeners[e].push(t), this.dom.addEventListener(e, t, s)));
    d(this, "removeEventListener", (e, t, s) => {
      this._listeners[e] || (this._listeners[e] = []);
      const i = this._listeners[e].indexOf(t);
      return i > -1 && this._listeners[e].splice(i, 1), this.dom.removeEventListener(e, t, s);
    });
    if (typeof e != "string" && e instanceof Element) {
      this.dom = e;
      return;
    }
    this.dom = document.createElement(e, t), this._listeners = {}, this._initReady();
  }
  attr(e, t) {
    if (typeof e == "string")
      return this.dom.setAttribute(e, t), this;
    for (const s in e)
      this.dom.setAttribute(s, e[s]);
    return this;
  }
  removeAttr(e) {
    return this.dom.removeAttribute(e), this;
  }
  val(e) {
    if (e === void 0)
      return this.dom.innerText;
    const t = (s) => {
      this.dom.innerText = s;
    };
    return t(_e(e, t, me)), this;
  }
  html(e) {
    if (e === void 0)
      return this.dom.innerHTML;
    const t = (s) => {
      this.dom.innerHTML = s;
    };
    return t(_e(e, t, me)), this;
  }
  addClass(e) {
    return e ? this.dom.classList.contains(e) ? this : (this.dom.classList.add(e), this) : this;
  }
  hasClass(e) {
    return this.dom.classList.contains(e);
  }
  removeClass(e) {
    return this.dom.classList.remove(e), this;
  }
  setSlot(...e) {
    return this.dom.innerHTML = "", this.append(...e), this;
  }
  removeAllEventListener(e) {
    const t = (s) => {
      for (const i of this._listeners[s])
        this.dom.removeEventListener(s, i);
    };
    if (arguments.length === 0 || e === void 0) {
      for (const s in this._listeners)
        t(s);
      return;
    }
    t(e);
  }
  css(e, t) {
    return t === void 0 ? this.dom.style[e] : (this.dom.style[e] = t, this.dom.style.length || this.removeAttr("style"), this);
  }
  find(e) {
    const t = this.dom.querySelector(e);
    return t === null ? null : new w(t);
  }
  findAll(e) {
    if (e.startsWith("#")) {
      const t = this.dom.querySelector(e);
      return t ? [new w(t)] : [];
    }
    if (e.startsWith(".")) {
      const t = this.dom.getElementsByClassName(e.substring(1));
      return Array.from(t).map((s) => new w(s));
    }
    return Array.from(this.dom.getElementsByTagName(e)).map((t) => new w(t));
  }
  prepend(...e) {
    return this.dom.prepend(
      ...e.map(
        (t) => this._unDom(t, (s) => {
          this._childAsDoms.unshift(s), this._execReady(s), s._inDom = !0;
        })
      )
    ), this;
  }
  append(...e) {
    return this.dom.append(
      ...e.map(
        (t) => this._unDom(t, (s) => {
          this._childAsDoms.push(s), this._execReady(s), s._inDom = !0;
        })
      )
    ), this;
  }
  replaceWith(...e) {
    const t = e.map((s) => this._unDom(s));
    return this.dom.replaceWith(...t), this.dom = t[0], this;
  }
  prependToNode(e) {
    try {
      return e || (e = document.body), e instanceof w ? (e.prepend(this), this._execReady(this), e) : (e.prepend(this.dom), e);
    } finally {
      this._execReady(this), this._inDom = !0;
    }
  }
  get visible() {
    const e = (i) => We(i);
    if (e(this.dom))
      return !1;
    let t = this.dom, s = this.dom.parentElement;
    for (; s !== null; ) {
      if (e(s))
        return !1;
      t = s, s = s.parentElement;
    }
    return t.tagName === "HTML";
  }
  get inDom() {
    return this._inDom;
  }
  appendToNode(e) {
    try {
      return e || (e = document.body), e instanceof w ? (e.append(this), e) : (e.appendChild(this.dom), e);
    } finally {
      this._execReady(this), this._inDom = !0;
    }
  }
  _execReady(e) {
    for (; e._insertedQueue.length; )
      e.ready(e._insertedQueue.shift());
  }
  show() {
    this.css("display", "");
  }
  hide() {
    this.css("display", "none");
  }
  dirtyCleaner(e) {
    this._dirtyQueue.includes(e) || this._dirtyQueue.push(e);
  }
  removeDirty() {
    const e = (t) => {
      for (; t._dirtyQueue.length > 0; )
        t._dirtyQueue.shift().apply(this);
    };
    e(this), this._childAsDoms.forEach((t) => {
      e(t);
    });
  }
  remove() {
    this.removeDirty(), this.dom.remove(), this._inDom = !1;
  }
  onInserted(e) {
    return this._insertedQueue.push(e), this;
  }
  _unDom(e, t) {
    return e instanceof w ? (t == null || t(e), e.dom) : e;
  }
  _initReady() {
    this._readyQueue = [];
    const e = this;
    function t(r) {
      for (; e._readyQueue.length; )
        e._readyQueue.shift().call(this, r);
    }
    const s = [], i = function() {
      for (; s.length > 0; )
        s.shift().apply(this);
    };
    if (document.addEventListener) {
      const r = function(c) {
        document.removeEventListener("DOMContentLoaded", r, !1), t.call(this, c);
      };
      document.addEventListener("DOMContentLoaded", r, !1), s.push(() => document.removeEventListener("DOMContentLoaded", r, !1)), this.dirtyCleaner(i);
    } else if (document.attachEvent) {
      const r = function(c) {
        document.readyState == "complete" && (document.detachEvent("onreadystatechange", r), t.call(this, c));
      };
      document.attachEvent("onreadystatechange", r), s.push(() => document.detachEvent("onreadystatechange", r)), this.dirtyCleaner(i);
    }
    const o = function(r) {
      window.removeEventListener("load", o, !1), t.call(this, r);
    };
    window.addEventListener("load", o, !1), s.push(() => window.removeEventListener("load", t, !1)), this.dirtyCleaner(i);
  }
  ready(e) {
    return document.readyState === "complete" ? e() : this._readyQueue.push(e), this;
  }
};
let a = w;
d(a, "createNode", (e) => {
  const t = document.createElement("div");
  return t.innerHTML = e, new w(t.childNodes[0]);
}), d(a, "create", (...e) => new w(...e)), d(a, "createSingle", Q(w.create));
a.createNode;
a.createSingle;
const et = (n) => `\\s*?(${n})\\s*?`, oe = (n) => `^${n}$`, tt = (n, ...e) => `^${n}\\(${e.map((t) => et(t)).join(",")}\\)$`, W = "\\b(?:[0-9]|[1-9][0-9]|(?:1[0-9]{2}|2[0-4][0-9]|25[0-5]))\\b", Le = "\\b(?:0(?:\\.\\d{1,})?|1(?:\\.0{1,})?)\\b", nt = "\\b(?:(?:\\d{1,2}(?:\\.\\d{1,3})?)|100)\\b%", st = (() => {
  const n = {
    is0to255: new RegExp(oe(W)),
    isDec0to1: new RegExp(oe(Le)),
    isPercent0to100: new RegExp(oe(nt))
  };
  return Object.keys(n).reduce((e, t) => (e[t] = (s) => n[t].test(s), e), {});
})(), it = {
  rgba: new RegExp(tt("rgba", W, W, W, Le))
}, be = {
  color: it,
  number: st
}, ot = {
  "gdpr-cookie-popup": "_gdpr-cookie-popup_1s7pr_1",
  "gdpr-cookie-mark": "_gdpr-cookie-mark_1s7pr_5",
  "gdpr-cookie-sheet": "_gdpr-cookie-sheet_1s7pr_14",
  "gdpr-cookie-center": "_gdpr-cookie-center_1s7pr_26"
}, I = (n, e) => typeof e != "string" ? (t) => n[t] ?? "" : (t) => n[t ? `${e}-${t}` : e] ?? "", se = I(ot, "gdpr-cookie");
class Ae extends a {
  constructor() {
    super("div"), this.addClass(se("popup"));
  }
  // 设置透明度
  setAlpha(e) {
    if (be.number.isDec0to1(e)) {
      if (this.css("background") === "")
        return this.css(
          "background",
          `rgba(255, 255, 255, ${e})`
        ), this;
      this.css(
        "background",
        this.css("background").replace(
          be.color.rgba,
          (t, s, i, o) => `rgba(${s}, ${i}, ${o}, ${e})`
        )
      );
    }
    return this;
  }
  autoZIndex(e = 1) {
    const t = Ze(this.dom), s = Ee(this.dom);
    (isNaN(s) || !isNaN(s) && s <= t) && this.css("zIndex", `${t + e}`);
  }
}
function D(n, e) {
  const t = {};
  e = { ...e };
  for (const s in n)
    if (s in e) {
      const i = e[s];
      i !== void 0 && (t[s] = i), delete e[s];
    } else
      t[s] = n[s];
  return Object.assign(t, e);
}
const rt = {
  center: !0
};
function ct(n) {
  n && this.addClass(se("center"));
}
function at(n) {
  switch (n) {
    case "bottom":
      this.css("bottom", "0");
      break;
    case "top":
      this.css("top", "0");
      break;
  }
}
const Y = class extends Ae {
  constructor(e) {
    super(), this._init(e ?? {});
  }
  _init(e) {
    return e = D(rt, e), ct.bind(this)(e.center), at.bind(this)(e.position), this.addClass(se("sheet")), this;
  }
};
let N = Y;
d(N, "create", (...e) => new Y(...e)), d(N, "createSingle", Q(Y.create));
const lt = "_btn_15dkw_1", dt = "_primary_15dkw_30", ut = "_ghost_15dkw_38", ht = "_block_15dkw_43", O = {
  btn: lt,
  "no-resize": "_no-resize_15dkw_24",
  primary: dt,
  ghost: ut,
  block: ht
}, pt = ["primary", "ghost"];
class le extends a {
  constructor(t) {
    super("a");
    d(this, "wrapper");
    d(this, "_type");
    this._init(), t !== void 0 && this.val(t);
  }
  setType(t) {
    if (this.hasClass(O[t]))
      return this;
    for (const s of pt) {
      const i = O[s];
      if (this.hasClass(i)) {
        this.removeClass(i);
        break;
      }
    }
    return this._type = t, this.addClass(O[this._type]), this;
  }
  noResize() {
    return this.addClass(O["no-resize"]), this;
  }
  _init() {
    this.addClass(O.btn), this.setType("primary");
  }
}
const ft = (n) => {
  let e, t;
  return (...s) => (t || (e = n(...s), t = !0), e);
}, yt = (n) => {
  const e = n.length - 1;
  return (t) => n[e - t];
};
function _t(n, e) {
  const t = n.indexOf(e);
  return t === -1 ? [n] : [n.substring(0, t), n.substring(t + 1)];
}
const mt = "_link_14zy7_1", ve = {
  link: mt,
  "none-user-select": "_none-user-select_14zy7_11"
};
class z extends a {
  constructor() {
    super("a"), this._init();
  }
  _init() {
    this.addClass(ve.link);
  }
  noSelect() {
    return this.addClass(ve["none-user-select"]), this;
  }
  setHref(e) {
    return this.attr("href", e), this;
  }
  setTarget(e) {
    return this.attr("target", e), this;
  }
}
const Re = ft(() => ({
  inferAllATags: /<a[^>]*>[^<]*<\/a>/g,
  inferAContent: /<a[^>]*>([^<]*)<\/a>/,
  inferAAttrsContent: /<a([^>]*)>[^<]*<\/a>/,
  inferAttrParts: /\S+=?(?:"\S*"|\S*)/g
}));
function gt(n) {
  var e, t;
  try {
    const s = Re(), i = ((e = n.match(s.inferAContent)) == null ? void 0 : e[1]) ?? "", r = (((t = n.match(s.inferAAttrsContent)) == null ? void 0 : t[1]) ?? "").match(s.inferAttrParts) ?? [], c = {};
    for (const u of r) {
      let [f, y] = _t(u, "=");
      if (f === "none-gdpr-compile") {
        c["none-gdpr-compile"] = y ?? "";
        continue;
      }
      typeof y < "u" && (y.startsWith('"') && y.endsWith('"') && (y = y.substring(1, y.length - 1)), c[f] = y);
    }
    if ("none-gdpr-compile" in c)
      return n;
    const l = new z();
    switch (l.val(i), c.href && l.setHref(c.href), c.target) {
      case "_blank":
      case "_self":
      case "_parent":
      case "_top":
        l.setTarget(c.target);
        break;
      default: {
        l.setTarget("_blank");
        break;
      }
    }
    return l;
  } catch {
    return n;
  }
}
function Pe(n) {
  const e = Re();
  return n.replace(e.inferAllATags, (t) => {
    const s = gt(t);
    return typeof s == "string" ? s : s.dom.outerHTML;
  });
}
const wt = {
  lockScroll: !0,
  passThrough: !1,
  mark: !0
};
function bt(n, e, t) {
  if (n) {
    const s = new a(document.querySelector("html")), i = (c) => {
      c.preventDefault();
    };
    let o = "";
    const r = () => {
      s.css("overflow", o);
    };
    e.push(() => {
      this.dom.removeEventListener("ontouchmove", i), s.css("overflow", o);
    }), t.push(() => {
      this.dom.addEventListener("ontouchmove", i), o = s.css("overflow"), s.css("overflow", "hidden"), this.dirtyCleaner(r);
    });
  }
}
function Ce(n) {
  n === !0 && this.css("pointer-events", "none");
}
const ee = class extends Ae {
  constructor(t) {
    super();
    d(this, "_vShow");
    d(this, "_options");
    this._vShow = S(!1), this.hide(), this._init(t ?? {});
  }
  _init(t) {
    this._options = t = D(wt, t);
    const s = [], i = [];
    this.addClass(se("mark")), t.mark ? (this.css("background", "rgba(0,0,0,0.8)"), bt.bind(this)(t.lockScroll, s, i), Ce.bind(this)(t.passThrough)) : Ce.bind(this)(!0), this._vShow.watch((o, r) => {
      if (o !== r) {
        if (o) {
          i.forEach((c) => c()), this.show();
          return;
        }
        s.forEach((c) => c()), this.hide();
      }
    });
  }
  setVShow(t) {
    var s, i, o, r, c, l, u, f;
    return t ? (((i = (s = this._options).onBeforeOpen) == null ? void 0 : i.call(s)) !== !1 && (this._vShow.value = !0, (r = (o = this._options).onOpened) == null || r.call(o)), this) : (((l = (c = this._options).onBeforeClose) == null ? void 0 : l.call(c)) !== !1 && (this._vShow.value = !1, (f = (u = this._options).onClosed) == null || f.call(u)), this);
  }
  get vShow() {
    return this._vShow.value;
  }
};
let M = ee;
d(M, "create", (...t) => new ee(...t)), d(M, "createSingle", Q(ee.create));
const vt = {
  "close-icon-large": "_close-icon-large_1ob9e_1",
  "close-icon-medium": "_close-icon-medium_1ob9e_15",
  "close-icon-small": "_close-icon-small_1ob9e_29",
  "close-icon-auto": "_close-icon-auto_1ob9e_43",
  "close-icon": "_close-icon_1ob9e_1"
}, Ct = ["large", "medium", "small", "auto"], K = I(vt, "close-icon");
class kt extends a {
  constructor() {
    super("span"), this._initCloseIcon();
  }
  setSize(e) {
    if (this.hasClass(K(e)))
      return this;
    for (const t of Ct) {
      const s = K(t);
      if (this.hasClass(s)) {
        this.removeClass(s);
        break;
      }
    }
    return this.addClass(K(e)), this;
  }
  _initCloseIcon() {
    this.addClass(K()), this.append(new a("span")), this.setSize("large");
  }
}
const De = {
  "policy-center": "_policy-center_1bhfu_1",
  "policy-center-header": "_policy-center-header_1bhfu_38",
  "policy-center-close": "_policy-center-close_1bhfu_48",
  "policy-center-body": "_policy-center-body_1bhfu_83",
  "policy-center-slider-body": "_policy-center-slider-body_1bhfu_95",
  "policy-center-slider-body-active": "_policy-center-slider-body-active_1bhfu_100",
  "policy-center-slider-body-content": "_policy-center-slider-body-content_1bhfu_109",
  "policy-center-slider": "_policy-center-slider_1bhfu_95",
  "policy-center-menu": "_policy-center-menu_1bhfu_163",
  "policy-center-menu-last": "_policy-center-menu-last_1bhfu_177",
  "policy-center-slider-body-header": "_policy-center-slider-body-header_1bhfu_197",
  "policy-center-slider-body-header-title": "_policy-center-slider-body-header-title_1bhfu_209",
  "policy-center-slider-body-content-explain": "_policy-center-slider-body-content-explain_1bhfu_233",
  "policy-center-slider-body-content-link": "_policy-center-slider-body-content-link_1bhfu_273",
  "policy-center-slider-switch": "_policy-center-slider-switch_1bhfu_289",
  "policy-center-menu-active": "_policy-center-menu-active_1bhfu_298",
  "policy-center-footer": "_policy-center-footer_1bhfu_306",
  "policy-center-btn": "_policy-center-btn_1bhfu_328",
  "policy-center-check-cookie-policy": "_policy-center-check-cookie-policy_1bhfu_333",
  "policy-center-horizontal": "_policy-center-horizontal_1bhfu_337",
  "policy-center-icon": "_policy-center-icon_1bhfu_341"
}, xt = "_active_rwhiy_11", St = "_slider_rwhiy_15", Tt = "_disabled_rwhiy_19", Ie = {
  switch: "_switch_rwhiy_1",
  active: xt,
  slider: St,
  disabled: Tt
}, j = I(Ie);
class Et extends a {
  constructor() {
    super("div");
    d(this, "_switchStatus", !1);
    d(this, "_disabled", S(!1));
    d(this, "_ref");
    this._initSwitch();
  }
  bindRef(t) {
    return typeof t == "boolean" ? (t && this._toActive(), this.disabled(), this) : (t.value && this._toActive(), t.watch((s, i) => {
      this._changeStatus(i);
    }), this._ref = t, this);
  }
  disabled() {
    return this._disabled.value = !0, this;
  }
  _changeStatus(t = this._switchStatus) {
    if (t) {
      this._toDisabled();
      return;
    }
    this._toActive();
  }
  _initSwitch() {
    this._disabled.watch((t, s) => {
      if (t !== s) {
        if (t) {
          this.addClass(j("disabled"));
          return;
        }
        this.removeClass(j("disabled"));
      }
    }), this.addClass(Ie.switch), this.append(new a("div").addClass(j("slider"))), this.addEventListener("click", () => {
      if (!this._disabled.value) {
        if (this._ref) {
          this._ref.value = !this._ref.value;
          return;
        }
        this._changeStatus();
      }
    });
  }
  _toActive() {
    return this._switchStatus = !0, this.addClass(j("active")), this;
  }
  _toDisabled() {
    return this._switchStatus = !1, this.removeClass(j("active")), this;
  }
}
const he = () => {
  const e = location.host.split("."), t = yt(e), s = t(0), i = t(1);
  if (s && i && i === "reolink")
    switch (s) {
      case "dev":
      case "review":
        return `${i}.${s}`;
      case "xyz": {
        const o = t(2);
        if (o === "alpha")
          return `${o}.${i}.${s}`;
        break;
      }
    }
  return "reolink.com";
}, Lt = () => `https://${he()}/cookie-policy/`, G = (() => {
  const n = Object.prototype.toString.call({});
  return (e) => typeof e == "object" && Object.prototype.toString.call(e) === n;
})(), ke = (n) => typeof n == "string" ? n : JSON.stringify(n), xe = (n, e = !0) => G(n) ? Object.keys(n).map(
  (t) => [t, e ? encodeURIComponent(ke(n[t])) : ke(n[t])].join("=")
).join("&") : "", At = {
  method: "GET",
  headers: {
    "Content-Type": "application/x-www-form-urlencoded"
  },
  timeout: 1e4,
  isBodyGetToPost: !0
}, re = (n, e) => {
  const t = D(At, {});
  return typeof n == "string" && (t.url = n), G(e) && Object.assign(t, D(t, e)), t;
}, Rt = (n) => {
  const e = {};
  return n.trim().split(/[\r\n]+/).forEach((t) => {
    const s = t.split(": "), i = s.shift(), o = s.join(": ");
    if (i) {
      if (i in e) {
        if (e[i] instanceof Array) {
          e[i].push(o);
          return;
        }
        e[i] = [e[i], o];
        return;
      }
      e[i] = o;
    }
  }), e;
}, Pt = (n) => {
  const e = {};
  return e.statusCode = n.status, e.statusText = n.statusText, e.responseHeaders = Rt(n.getAllResponseHeaders()), e.rawBody = () => new Blob([n.response], { type: e.responseHeaders["content-type"] }), e.text = () => n.responseText, e.json = () => JSON.parse(e.text()), e;
};
class J {
  constructor() {
    d(this, "_xhr");
  }
  abort() {
    this._xhr.onreadystatechange = function() {
    }, this._xhr.abort();
  }
  request(e, t) {
    const s = re(e, t);
    return this._request(s);
  }
  _request(e) {
    return new Promise((t, s) => {
      e.isBodyGetToPost && (e.body || typeof e.body == "string") && e.method === "GET" && (e.method = "POST"), e.body && typeof e.body == "object" && (e.headers["Content-Type"] = "application/json"), e.url = this._dealQuery(e), this._xhr = new XMLHttpRequest(), this._xhr.open(e.method, e.url, !0), this._dealHeaders(e), e.timeout && (this._xhr.timeout = e.timeout, this._xhr.ontimeout = () => {
        s("Connected timeout");
      }), this._xhr.onreadystatechange = () => {
        this._xhr.readyState === XMLHttpRequest.DONE && (this._xhr.status === 200 && t(Pt(this._xhr)), s(this._xhr.responseText));
      }, this._xhr.onerror = (i) => s(i), this._xhr.send(this._dealBody(e));
    });
  }
  static get(e, t) {
    const s = re(e, t);
    return s.method = "GET", s.isBodyGetToPost = !1, new J()._request(s);
  }
  static post(e, t) {
    const s = re(e, t);
    return s.method = "POST", s.isBodyGetToPost = !1, new J()._request(s);
  }
  _dealQuery(e) {
    let t = e.url, s;
    const i = t.includes("?"), o = e.query;
    if (o)
      if (t += i ? "&" : "?", G(o))
        t += xe(e.query);
      else if ((s = typeof o) == "string")
        t += o;
      else
        throw new TypeError(`The type of query expect 'string'! but found ${s ?? typeof o}!`);
    return t;
  }
  _dealBody(e) {
    const t = e.body;
    let s;
    if (!t || (s = typeof t) == "string")
      return t;
    if (G(t)) {
      if (e.headers["Content-Type"] === "application/json")
        return JSON.stringify(t);
      if (e.headers["Content-Type"] === "application/x-www-form-urlencoded")
        return xe(t);
    }
    throw new TypeError(`The type of body expect 'string'! but found ${s}!`);
  }
  _dealHeaders(e) {
    const t = e.headers;
    if (G(t))
      for (const s in t)
        this._xhr.setRequestHeader(s, t[s]);
  }
}
const Dt = async (n) => {
  var s, i;
  const e = C("lang-domain")();
  return ((i = (s = (await J.get(`https://${e}/wp-json/reo-v2/i18n/package`, {
    query: {
      package: C("lang-package"),
      lang: n,
      "no-mobile-redirection": "1"
    }
  })).json()) == null ? void 0 : s.data) == null ? void 0 : i[C("lang-package")]) ?? {};
}, Se = (n) => {
  let e, t = !1;
  return () => (t || (e = n(), t = !0), e);
}, It = {
  key: "gdprNewLocalName",
  "lang-domain": Se(he),
  "policy-link": Se(Lt),
  "lang-package": "cookie-gdpr",
  explainFlag: "●"
}, C = (n) => It[n] ?? n, _ = I(De, "policy-center"), Be = (n) => {
  const e = [];
  let t = 1, s = n;
  for (; !ge(s) && we(s) !== s; ) {
    const i = we(s), o = e.push(Pe(i)), r = (l) => {
      const u = new a("div");
      return u.addClass(_("slider-body-content-explain")), u.append(...l.map((f) => new a("div").val(f))), u.dom.outerHTML;
    }, c = e[o - 1].indexOf(C("explainFlag"));
    if (c > -1) {
      const l = e[o - 1].substring(c + 1).split(C("explainFlag")).map((u) => u.trim());
      e[o - 1] = e[o - 1].substring(0, c) + r(l);
    } else
      !s.endsWith("explain") && !ge(`${s}-explain`) && (e[o - 1] += r(Be(`${s}-explain`)));
    t++, s = `${n}-${t}`;
  }
  return e;
}, $ = (n) => Be(n).join("<br><br>"), H = (n, e, t) => {
  const s = new a("div").addClass(_("slider-body")), i = new a("div").addClass(_("slider-body-header")), o = new a("div").addClass(_("slider-body-header-title")).val(n);
  i.append(o), t && i.append(t);
  const r = new a("div").addClass(_("slider-body-content")).html(e);
  return s.append(i, r), s;
}, Bt = () => [
  new a("div").addClass(_("menu")).append(new a("span").val(p("what-are-cookies"))),
  new a("div").addClass(_("menu")).append(new a("span").val(p("essential-cookies"))),
  new a("div").addClass(_("menu")).append(new a("span").val(p("functional-cookies"))),
  new a("div").addClass(_("menu")).append(new a("span").val(p("marketing-cookies"))),
  new a("div").addClass(_("menu")).append(new a("span").val(p("advertising-cookies"))).addClass(_("menu-last"))
], q = (n) => {
  const e = new Et().bindRef(n);
  return e.addClass(_("slider-switch")), e;
}, Te = (n) => [
  H(p("what-are-cookies"), () => {
    const e = $("what-are-cookies-paragraph"), t = new a("div").addClass(_("slider-body-content-link")), s = new z().setHref(C("policy-link")()).setTarget("_blank").addClass(_("check-cookie-policy")).val(p("check-cookie-policy"));
    t.append(s);
    {
      t.addClass(_("horizontal"));
      const o = new a("span");
      o.addClass(_("icon")), o.dom.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" version="1.1" width="100%" height="100%" viewBox="0 0 20 20"><defs><clipPath id="master_svg0_728_19941"><rect x="20" y="20" width="100%" height="100%" rx="0"></rect></clipPath></defs><g transform="matrix(-1,1.8814782265508256e-7,-1.8814782265508256e-7,-1,40.00001128886936,39.999996237042836)" clip-path="url(#master_svg0_728_19941)"><g transform="matrix(0,1,-1,0,56.66699595045645,-11.178714700456453)"><path d="M48.434655325456454,23.922650625L41.178775325456456,31.178570625L33.92285532545645,23.922650625L35.101365325456456,22.744140625L41.178775325456456,28.821550625L47.256155325456454,22.744140625L48.434655325456454,23.922650625Z" fill-rule="evenodd" fill="currentColor" fill-opacity="1"></path></g></g></svg>', t.append(o);
    }
    const i = t.dom.outerHTML;
    return [e, i].join("");
  }),
  H(
    p("essential-cookies"),
    () => $("essential-cookies-paragraph"),
    q(n.essential)
  ),
  H(
    p("functional-cookies"),
    () => $("functional-cookies-paragraph"),
    q(n.functional)
  ),
  H(
    p("marketing-cookies"),
    () => $("marketing-cookies-paragraph"),
    q(n.marketing)
  ),
  H(
    p("advertising-cookies"),
    () => $("advertising-cookies-paragraph"),
    q(n.advertising)
  )
], L = () => {
}, Oe = {
  pageClick: L,
  confirmChoice: L,
  allowAll: L,
  rejectAll: L
}, V = (n) => Oe[n] ?? null, ce = (n, e) => {
  Oe[n] = e;
}, je = {
  gdprCookie: {
    essential: !0,
    functional: S(!1),
    marketing: S(!1),
    advertising: S(!1)
  }
}, F = (n) => je[n], Ot = (n) => {
  const e = { ...je[n] };
  if (typeof e == "object")
    for (const t in e)
      e[t] = Z(e[t]);
  return e;
}, E = (n, e) => {
  try {
    return n[e];
  } finally {
    delete n[e];
  }
}, m = I(De, "policy-center"), jt = {
  maskClosable: !1
}, $t = {
  initIndex: 0
}, te = class extends M {
  constructor(t) {
    t = t ?? {};
    const s = (() => {
      const i = t;
      return (o) => E(i, o);
    })();
    super({
      mark: !0,
      onBeforeOpen: s("onBeforeOpen"),
      onOpened: s("onOpened"),
      onBeforeClose: s("onBeforeClose"),
      onClosed: s("onClosed")
    });
    d(this, "centerWrapper");
    this._initPolicyCenter(), this._initPolicyCenterOptions(t);
  }
  _initPolicyCenter() {
    this.setAlpha("0.4"), this.css("zIndex", "1001"), this.centerWrapper = new a("div"), this.centerWrapper.addClass(m()), this.centerWrapper.append(
      this._initHeader(),
      this._initBody(),
      this._initFooter()
    ), this.centerWrapper.appendToNode(this), this.ready(() => {
      this.autoZIndex(2);
    });
  }
  _initPolicyCenterOptions(t) {
    t = D(jt, t), t.maskClosable && (this.centerWrapper.addEventListener("click", (s) => s.stopPropagation()), this.addEventListener("click", () => this.setVShow(!1)));
  }
  _initHeader() {
    const t = new a("div");
    t.addClass(m("header"));
    const s = new kt();
    return s.setSize("auto"), s.addClass(m("close")), s.addEventListener("click", () => {
      this.setVShow(!1);
    }), t.append(
      new a("span").val(p("privacy-preference-center")),
      s
    ), t;
  }
  _initBody() {
    const t = new a("div");
    t.addClass(m("body"));
    const s = new a("div"), [i, o] = this._initSliderMenus({});
    return s.append(
      ...i
    ), s.addClass(m("slider")), t.append(
      s,
      ...o
    ), t;
  }
  _initSliderMenus(t) {
    t = D($t, t);
    const s = Bt(), i = Te(F("gdprCookie")), o = Te(F("gdprCookie")), r = [], c = [];
    for (let l = 0, u = s.length; l < u; l++)
      ((f) => {
        const y = s[f], T = i[f], fe = o[f], Ge = () => {
          var B;
          ((B = t.onBeforeActive) == null ? void 0 : B.call(t, f)) !== !1 && (c[0].menu.removeClass(m("menu-active")), c[0].sliderBody.removeClass(m("slider-body-active")), c[0].cloneSliderBody.removeClass(m("slider-body-active")));
        }, ye = () => {
          var B;
          y.addClass(m("menu-active")), T.addClass(m("slider-body-active")), fe.addClass(m("slider-body-active")), Je(c, { menu: y, sliderBody: T, cloneSliderBody: fe }, 1), (B = t.onActived) == null || B.call(t, f, i[f]);
        };
        t.initIndex === f && ye(), y.addEventListener("click", () => {
          if (c.length !== 0) {
            if (c[0].menu === y)
              return;
            Ge();
          }
          ye();
        }), r.push(y, T);
      })(l);
    return [r, o];
  }
  _initFooter() {
    const t = new a("div");
    t.addClass(m("footer"));
    const s = new le(p("confirm-my-choices")).setType("ghost").addClass(m("btn"));
    s.addEventListener("click", () => {
      this.remove(), V("confirmChoice")();
    });
    const i = new le(p("allow-all")).addClass(m("btn"));
    return i.addEventListener("click", () => {
      this.remove(), V("allowAll")();
    }), t.append(s, i), t;
  }
};
let A = te;
d(A, "create", (...t) => new te(...t)), d(A, "createSingle", Q(te.create));
const de = {}, Ht = (n) => {
  Object.assign(de, n);
}, Nt = {
  "policy-popup": "_policy-popup_1e6n1_1",
  "policy-popup-wrapper": "_policy-popup-wrapper_1e6n1_9",
  "policy-popup-content": "_policy-popup-content_1e6n1_23",
  "policy-popup-btn-layout": "_policy-popup-btn-layout_1e6n1_35",
  "policy-popup-btn-layout-allow": "_policy-popup-btn-layout-allow_1e6n1_47",
  "policy-popup-btn-allow-all": "_policy-popup-btn-allow-all_1e6n1_50",
  "policy-popup-btn-layout-user": "_policy-popup-btn-layout-user_1e6n1_66",
  "policy-popup-btn-setting-link": "_policy-popup-btn-setting-link_1e6n1_73",
  "policy-popup-btn-user-setting": "_policy-popup-btn-user-setting_1e6n1_94",
  "policy-popup-btn-user-reject": "_policy-popup-btn-user-reject_1e6n1_97",
  "policy-popup-btn-setting": "_policy-popup-btn-setting_1e6n1_73"
}, g = I(Nt, "policy-popup"), ne = class extends N {
  constructor(...e) {
    super(...e), this._initPolicyPopup();
  }
  _initPolicyPopup() {
    this.addClass(g());
    const e = new a("div").addClass(g("wrapper"));
    this.append(e);
    const t = new a("div").addClass(g("content")), s = new z().setHref(C("policy-link")()).setTarget("_self").css("cursor", "pointer").val(p("cookie-policy"));
    t.html(
      Ve(
        p("popup-tip", () => s.dom.outerHTML),
        Pe
      )
    ), e.append(t);
    const i = new a("div").addClass(g("btn-layout")), o = new z().noSelect().addClass(g("btn-setting")).val(p("cookie-settings"));
    let r;
    this.dirtyCleaner(() => {
      r && r.remove();
    }), o.addEventListener("click", () => {
      if (!r) {
        r = new A(de), r.appendToNode(), r.setVShow(!0);
        return;
      }
      if (r && !r.inDom) {
        r = A.create(de), r.appendToNode(), r.setVShow(!0);
        return;
      }
      r.setVShow(!0);
    });
    const c = new le().val(p("got-it"));
    c.addEventListener("click", V("allowAll"));
    {
      o.addClass(g("btn-user-setting")), c.noResize().addClass(g("btn-allow-all")).addClass(g("btn-setting-link"));
      const l = new a("div").addClass(g("btn-layout-allow")), u = new a("div").addClass(g("btn-layout-user")), f = new z().noSelect().addClass(g("btn-setting")).addClass(g("btn-user-reject")).val(p("reject-all"));
      f.addEventListener("click", V("rejectAll"));
      const y = new a("span").addClass(g("btn-setting-link"));
      y.append(f);
      const T = new a("span").addClass(g("btn-setting-link"));
      T.append(o), u.append(y, T), l.append(c), i.append(u, l);
    }
    e.append(i), this.ready(() => {
      this.autoZIndex(1);
    });
  }
};
let R = ne;
d(R, "create", (...e) => new ne(...e)), d(R, "createSingle", Q(ne.create));
const U = {
  cacheCookie: {},
  // 根据key展示cookie
  showCookieByKey: function(n) {
    const e = this.cacheCookie[n];
    if ((() => (e == null ? void 0 : e.value) === void 0 || e.expiresTime ? !1 : e.expiresTime <= (/* @__PURE__ */ new Date()).getTime())())
      return e.value;
    const s = document.cookie, i = encodeURIComponent(n) + "=", o = s.indexOf(i);
    let r = null;
    if (o > -1) {
      let c = s.indexOf(";", o);
      c == -1 && (c = s.length), r = decodeURIComponent(s.substring(o + i.length, c));
    }
    return r;
  },
  // 暂时修复为：取域名的后两级为cookie的目标域
  addDomain: function() {
    return `.${he()}`;
  },
  // 设置cookie
  setCookie: function(n, e, t, s, i, o) {
    let r = !0, c, l = encodeURIComponent(n) + "=" + encodeURIComponent(e);
    if (t instanceof Date && (c = t.getTime(), l += ";expires=" + t.toGMTString(), c < (/* @__PURE__ */ new Date()).getTime() && (r = !1)), s && (l += "; path=" + s), i && (l += ";domain=" + i), o && (l += "; secure"), document.cookie = l, !r)
      delete this.cacheCookie[n];
    else {
      const u = {};
      u[n] = { value: e, expiresTime: c }, Object.assign(this.cacheCookie, u);
    }
  }
}, x = {
  localKey: C("key"),
  euCountries: {
    AT: "AT",
    BE: "BE",
    BG: "BG",
    HR: "HR",
    CY: "CY",
    CZ: "CZ",
    DK: "DK",
    EE: "EE",
    FI: "FI",
    FR: "FR",
    DE: "DE",
    GR: "GR",
    HU: "HU",
    IE: "IE",
    IT: "IT",
    LV: "LV",
    LT: "LT",
    LU: "LU",
    MT: "MT",
    NL: "NL",
    PL: "PL",
    PT: "PT",
    RO: "RO",
    SK: "SK",
    SI: "SI",
    ES: "ES",
    SE: "SE",
    GB: "GB",
    NO: "NO",
    CH: "CH",
    IS: "IS"
  },
  extraCountries: {
    US: "US",
    RU: "RU"
  },
  /**
   * 首次进入时，没有权限存储数据，默认为true
   * 欧盟、非欧盟都执行
   * key {} : 空、有值
   * 为空时，默认为true，欧盟、非欧盟都执行
   * 不为空时，说明是经过设置的，即该国家为欧盟国家，再根据其结果进行对应的设置
   */
  getGDPRPermission: function(n) {
    const e = JSON.parse(U.showCookieByKey(this.localKey));
    if (e) {
      if (n in e)
        return e[n];
    } else
      return !0;
  },
  setPermission: function(n) {
    n instanceof Object && U.setCookie(
      this.localKey,
      JSON.stringify(n),
      new Date((/* @__PURE__ */ new Date()).getTime() + 1e3 * 86400 * 365),
      "/",
      U.addDomain()
    );
  },
  // 是欧盟国家吗？
  isEurap: function(n) {
    return n in x.euCountries || n in x.extraCountries;
  },
  /**
   * 判断是否是初始状态：根据localStorage里是否有localkey
   * 有：不是初始状态：返回有localkey的否定值 => false
   * 无：是初始状态：返回无localkey的否定值 => true
   */
  isInitialState: function() {
    return !JSON.parse(U.showCookieByKey(this.localKey));
  }
}, pe = () => U.showCookieByKey(C("key")), Mt = () => JSON.parse(pe()), ie = () => {
  const { functional: n, marketing: e, advertising: t } = Ot("gdprCookie");
  return { features: n, ads: e, googleAdsTracking: t };
}, X = (n) => {
  const e = F("gdprCookie");
  e.functional.value = (n == null ? void 0 : n.features) ?? e.functional.value, e.marketing.value = (n == null ? void 0 : n.ads) ?? e.marketing.value, e.advertising.value = (n == null ? void 0 : n.googleAdsTracking) ?? e.advertising.value;
}, $e = () => {
  X(Mt());
}, He = () => {
  const n = F("gdprCookie");
  return n.functional.value = !0, n.marketing.value = !0, n.advertising.value = !0, ie();
}, Ut = () => {
  const n = F("gdprCookie");
  return n.functional.value = !1, n.marketing.value = !1, n.advertising.value = !1, ie();
}, h = {}, v = {}, zt = (n) => {
  Object.assign(h, {
    onAllowAlled: E(n, "onAllowAlled"),
    onAllowAllBefore: E(n, "onAllowAllBefore"),
    onConfirmBefore: E(n, "onConfirmBefore"),
    onConfirmed: E(n, "onConfirmed"),
    onRejectAlled: E(n, "onRejectAlled")
  }), Ht(n);
}, Gt = async (n) => {
  const t = await (v.i18n ?? (v.i18n = Dt(n)));
  Xe(t);
};
let b, P, ue = !1;
const Ne = () => {
  b == null || b.appendToNode();
}, Ft = async (n) => {
  try {
    ue = !0, await P;
  } finally {
    n !== !1 && Ne(), P = null, ue = !1;
  }
}, Qt = () => {
  ce("confirmChoice", () => {
    var n, e;
    ((n = h.onConfirmBefore) == null ? void 0 : n.call(h)) !== !1 && (x.setPermission(ie()), b.remove(), (e = h.onConfirmed) == null || e.call(h));
  }), ce("allowAll", () => {
    var n, e;
    ((n = h.onAllowAllBefore) == null ? void 0 : n.call(h)) !== !1 && (x.setPermission(He()), b.remove(), (e = h.onAllowAlled) == null || e.call(h));
  }), ce("rejectAll", () => {
    var n, e;
    ((n = h.onRejectAllBefore) == null ? void 0 : n.call(h)) !== !1 && (x.setPermission(Ut()), b.remove(), (e = h.onRejectAlled) == null || e.call(h));
  });
}, Me = (n) => x.isEurap(n), Ue = (n, e) => (P = Gt(n), Qt(), b = new R(), Ft(e)), Kt = (n, e, t) => {
  v.i18n = null, v.country = n, v.lang = e, pe() || (Me(n) ? Ue(e, t).catch(L) : x.setPermission(He()), x.euCountries[n] ? X({
    features: !1,
    ads: !1,
    googleAdsTracking: !1
  }) : X({
    features: !1,
    ads: !1,
    googleAdsTracking: !0
  }));
}, ze = () => !!b, qt = (n) => {
  const e = Ke("allTrue", () => {
    b = new R(), Ne();
  });
  if (e.register(b && !b.inDom), n && P && !ue) {
    (async () => {
      try {
        await P;
      } catch {
      } finally {
        e.executor();
      }
    })();
    return;
  }
  e.register(!P), e.executor();
}, Wt = (n, e = {}) => {
  if (e.country && (v.country = e.country), e.lang && (v.lang = e.lang), n && !ze()) {
    if (typeof v.lang > "u") {
      console.warn("GDPR isn't inited.");
      return;
    }
    b || (pe() && $e(), Ue(v.lang).catch(L));
    return;
  }
  return qt(n);
}, Zt = {
  key: C("key"),
  init: Kt,
  isInit: ze,
  isEurap: Me,
  show: Wt,
  getGdprSetting: ie,
  setGdprSetting: X,
  setGdprOptions: zt,
  setGdprSettingByCookie: $e
};
Object.defineProperty(Zt, "gdprUtil", {
  enumerable: !1,
  get() {
    return x;
  }
});
export {
  Zt as default
};
